export default __webpack_public_path__ + "static/logotype-de9ca665c14e5908db502e4cb6efbda1.svg";